import React from "react";

const NoRecord = (props) => {
    return(<>
    <div>{props.message}</div>
    </>);
}
export default NoRecord;